import React, { Component } from 'react';

import '../../stylesheets/timer.css';

class Timer extends Component{
    constructor(props){
        super(props);
        this.state={
            hh:0,
            mm:0,
            ss:0,
            time:{h:0,m:0,s:0},
            action:null,
            errorMsg:null,
            colors:['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
            '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
            '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
            '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],
            colorChosen:'#000',
            timers:null

        }
        this.interval=null;
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }

     minus(){
        let {hh,mm,ss} = this.state;
        if (hh > 0 || mm > 0 || ss > 0) {
            if(ss>0){
                ss--;
               
                this.setState({ss});
            }
            if (ss === 0) {
              if (mm > 0) {
                mm--;
                this.setState({ mm, ss: 60 });
              }
              if (mm === 0 ){
                  hh = this.state.hh;
                  
                if(hh > 0){
                 
                  hh--;
                  this.setState({hh,mm:59,ss:60});
                }
                if(ss>0){
                    ss--;
                    
                    this.setState({ss});
                }
                
                //
                this.alarm();
                
              }
      
            }
          }
    }

    async alarm(){
        let {hh,mm,ss,action,colors} = this.state;
        if( ss === 0 &&  mm === 0 && hh === 0 && action==='started'){
            for(let i of colors){
                this.setState({colorChosen:i});
                if(this.state.action==='started'){
                    await this.sleep(500);
                }else{
                    break;
                }
            }
            
            
        }
        this.clear();
    }

    check(){
        //let {hh,mm,ss} = this.state;
        let {time} = this.state;
         let start = true;
        start = (time.h === 0 && time.m === 0 && time.s === 0) ? false : true
        //console.log(errorMsg);
        
        return start;
    }

    getRandomColor(){
        let {colors} = this.state;
        let i = Math.floor(Math.random() * colors.length);
        return colors[i];
    }
    
    errorMessage(){
        let {errorMsg} = this.state;
        const danger={
            color:'red',
            fontSize:'0.5em',
        }
        const msg=(errorMsg==='empty') ?  'Fields cannot be empty.' : 'Enter a valid number';
        return(
            <div style={danger} className='col'> 
               {msg}
            </div>
        )
    }

    start(){
        //let action=null;
        let {time} = this.state;
        if(this.check()){
        this.setState({ 
             hh:time.h,
             mm:time.m,
             ss:time.s,
             action:'started'
            }
        );
        this.inputHH.value = this.inputMM.value = this.inputSS.value = '';
        this.interval = setInterval(() => this.minus(), 1000);
        //this.setState({action:'started'});
        //console.log(this.interval,this.state);
        }else{
            this.setState({errorMsg:'empty'});
        }
        
    }
    pause(){
        //console.log('stop',this.state);
        clearInterval(this.interval);
        this.setState({action:'stopped'});
    }
    stop(){
        //console.log('stop',this.props);
        this.pause();
        this.clear();
        this.interval=null;
    }
    clear(){
        let {time} = this.state;
        this.pause();
        time.h = time.m = time.s = 0;
        this.setState({
            hh:0,
            mm:0,
            ss:0,
            time,
            action:null,
            colorChosen:'#000',
            errorMsg:null
        
        });
        this.interval=null;
        this.inputHH.value = this.inputMM.value = this.inputSS.value = '';
    }

    leadingZero(num){
        num = (num<10) ? '0'+num : num
        return num;
    }

    timeBox(){
        return(
            <div className='row time-box-row'>
            <div className='col'>{this.leadingZero(this.state.hh)}</div>:
            <div className='col'>{this.leadingZero(this.state.mm)}</div>:
            <div className='col'>{this.leadingZero(this.state.ss)}</div>
            </div>
        )
    }

    onChangeHandler(key,value){
        let error=null;
        let chkValue = null;
        //console.log(typeof value);
        
        chkValue = (value==='' || value==="") ? 0 : value;
        error = (value==='') ? 'empty' : null;
        chkValue = (isNaN(value)) ? 0 : value
        error = (isNaN(value)) ? 'NaN' : null;
        
        let {time} = this.state;
        if(key==='ss'){
            time.s=chkValue;
            this.setState({time,errorMsg:error});
        }
        if(key==='mm'){
            time.m=chkValue;
            this.setState({time,errorMsg:error});
        }
        if(key==='hh'){
            time.h=chkValue;
            this.setState({time,errorMsg:error});
        }
        
        //console.log('myValue',this.state);
    }

    inputBox(){
        let {action,errorMsg} = this.state;
        let shouldDisable=(action==='started' || action==='stopped')?'disabled':null
        let checkDanger=(errorMsg==='empty' || errorMsg==='NaN' ) ? 'time-input-danger':''
        return(
            <div className='row input-row'>
            
            <input 
            className={`form-control col time-input ${checkDanger}`}
            type='text' 
            placeholder='hh'
            onChange={(event)=>{
               this.onChangeHandler('hh',event.target.value);
            }}
            disabled={shouldDisable}
            maxLength="2"
            ref={el => this.inputHH = el}/>
            <input 
            className={`form-control col time-input ${checkDanger}`}
            type='text' 
            placeholder='mm'
            onChange={(event)=>{
                this.onChangeHandler('mm',event.target.value);
            }}
            disabled={shouldDisable}
            maxLength="2"
            ref={el => this.inputMM = el}/>
            <input 
            className={`form-control col time-input ${checkDanger}`}
            type='text'
            placeholder='ss' 
            onChange={(event)=>{
                this.onChangeHandler('ss',event.target.value);
            }}
            disabled={shouldDisable}
            maxLength="2"
            ref={el => this.inputSS = el}/>
            </div>
        )
    }

    buttonBox(){
        let {time,action,errorMsg} = this.state;
        let myClass = `fa fa-${(action==='started')?'pause':'play'}`;
        let myAction  = (action==='started')?()=>this.pause():()=>this.start();
        let showError=(errorMsg==='empty' || errorMsg==='NaN') ? this.errorMessage() : null
        
        return(
            <div>
                <button 
                className='btn time-btn' 
                onClick={myAction}><i className={myClass}></i></button>
                <button 
                className='btn time-btn' 
                onClick={()=>this.stop()}
                disabled={action==null?'disabled':null}><i className='fas fa-stop'></i></button>
                <button 
                className='btn time-btn' 
                onClick={()=>this.clear()}
                disabled={(time.h!==0 || time.m!==0 || time.s!==0)?null:'disabled'}><i className='fas fa-backspace'></i></button>
                {showError}
            </div>
        )
    }

    render(){
        return(
            <div className='App container'>
                <div className='App-title'>Timer <i style={{color:this.state.colorChosen}}className='fas fa-stopwatch'></i></div>
                <div>
                {this.timeBox()}
                {this.inputBox()}
                {this.buttonBox()}
                </div>       
            </div>
        )
    }
}




export default Timer;


// WEBPACK FOOTER //
// ./src/components/timer/Timer.jsx